import { NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { useUIStore } from '@/stores/uiStore'
import { BottomSheet } from '@/components/ui/BottomSheet'
import {
  Users, Layers, Calendar,
  GitBranch, Megaphone, BarChart3, Settings
} from 'lucide-react'

const MORE_ITEMS = [
  { label: 'Customers',    path: '/customers',    icon: Users },
  { label: 'Work',         path: '/work',         icon: Layers },
  { label: 'Calendar',     path: '/calendar',     icon: Calendar },
  { label: 'Workflows',    path: '/workflows',    icon: GitBranch },
  { label: 'Marketing',    path: '/marketing',    icon: Megaphone },
  { label: 'Reports',      path: '/reports',      icon: BarChart3 },
  { label: 'Settings',     path: '/settings',     icon: Settings },
] as const

export function MoreMenuSheet() {
  const { moreMenuOpen, setMoreMenuOpen } = useUIStore()
  const close = () => setMoreMenuOpen(false)

  return (
    <BottomSheet
      open={moreMenuOpen}
      onClose={close}
      title="More"
      showHandle
      size="md"
    >
      <div className="grid grid-cols-3 gap-1 pb-2">
        {MORE_ITEMS.map(({ label, path, icon: Icon }) => (
          <NavLink
            key={path}
            to={path}
            onClick={close}
            className={({ isActive }) => cn(
              'flex flex-col items-center justify-center gap-1.5 p-3 rounded-xl min-h-[72px]',
              'transition-all duration-150 active:opacity-70',
              isActive
                ? 'bg-white/[0.08] text-ink-50'
                : 'text-ink-400 hover:bg-white/[0.04] hover:text-ink-100'
            )}
          >
            <Icon className="w-6 h-6" />
            <span className="text-[11px] font-medium leading-tight text-center">{label}</span>
          </NavLink>
        ))}
      </div>
    </BottomSheet>
  )
}
